import React from 'react'
import { useTranslation } from 'react-i18next'
import { Font } from 'is24-corecss'

const AddressPopoverContent = () => {
  const { t } = useTranslation()

  return (
    <div>
      <Font className='margin-bottom'>{t('wizard.screen.address.popover.description1')}</Font>
      <Font>
        <strong>{t('wizard.screen.address.popover.description2.header')}</strong>
        {t('wizard.screen.address.popover.description2.content')}
      </Font>
    </div>
  )
}
export default AddressPopoverContent
